import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { compose, withProps } from "recompose";
import {
  withQuery,
  withTableHandlers,
  withApi,
  withHeaderFooter
} from "features/query";
import withBatch from "features/batch";
import { selectors } from "reducers";
import Table from "components/ui/impl/table";
import { formatDate } from "utils/misc";
import { outreachCycleOptions } from "utils/enum";
import ComplianceOutreachCoachFilter from "./compliance-outreach-coach-filter";
import TableControls from "./table-controls";
import CompanyBranchFilter from "components/order-status/company-branch-filter";

const formatEligBool = ({ over_elig_date }) => (over_elig_date ? "Yes" : "No");

const SleepcoachDashboardTable = compose(
  connect(state => ({
    sleepCoachOptions: selectors.getFormOptionsSleepCoachWithUserFirst(state),
    contactActionsOptions: selectors.getContactActionsOptions(state),
    formOfContactOptions: selectors.getFormOfContactOptions(state),
    companyOptions: selectors.getFormOptionsCompany(state),
    userId: selectors.getUserId(state),
    userTeam: selectors.getUserTeam(state),
    userRole: selectors.getUserRole(state),
    teamNameOptions: selectors.getTeamNameOptionsKeyAsValue(state),
    insuranceTypeNames: selectors
      .getFormOptionsInsurance(state)
      .map(({ text, value }) => ({ text, value }))
  })),
  withQuery({
    queryId: "sleepcoach-dashboard-table"
  }),
  withApi({
    apiId: "sleepcoach-dashboard-table",
    api: {
      route: "patients/compliance/needs_contact",
      responseKey: "patients",
      idKey: "id",
      entityKey: "dashboardRows"
    }
  }),
  withBatch({ recordIdKey: "id" }),
  withProps(
    ({
      markedForBatch,
      markForBatch,
      batchColumn,
      companyOptions,
      // contactActionsOptions,
      formOfContactOptions,
      requestData,
      batchClear,
      insuranceTypeNames,
      teamNameOptions,
      userRole,
      complianceCoachOptions
    }) => ({
      columns: [
        batchColumn,
        {
          header: "Name",
          field: "last_name",
          format: ({ first_name, last_name, id }) => (
            <Link to={`/patients/${id}`}>
              {first_name} {last_name}
            </Link>
          )
        },
        ["SleepCoach", "Administrator"].includes(userRole)
          ? {
              header: "Company",
              field: "company",
              filters: companyOptions,
              filterKey: "company_id",
              filterDownSelect: true
            }
          : {
              header: "Company",
              field: "company",
              renderFilter: props => <CompanyBranchFilter {...props} />
            },
        {
          header: "Branch",
          field: "company_branch_name",
          filterKey: "company_branch_guid",
          filterDownSelect: true
        },
        {
          header: "Compliance Coach",
          field: "compliance_coach",
          renderFilter: props => (
            <ComplianceOutreachCoachFilter
              {...props}
              teamNameOptions={teamNameOptions}
              complianceCoachOptions={complianceCoachOptions}
            />
          ),
          filterKey: "compliance_coach_id",
          filterDownSelect: true
        },
        {
          header: "Team",
          field: "team_name",
          filters: teamNameOptions,
          filterKey: "team_id"
        },
        {
          header: "Form of Contact",
          field: "form_of_contact",
          filters: formOfContactOptions
        },
        {
          header: "Cycle",
          field: "patient_outreach_cycle_count",
          filters: outreachCycleOptions
        },
        {
          header: "Compliance %",
          field: "compliance_percentage"
        },
        {
          header: "Set up Date",
          format: ({ setup_date }) => formatDate(setup_date),
          field: "setup_date"
        },
        {
          header: "Days from set up",
          field: "days_from_setup_date"
        },
        {
          header: "Override Date",
          field: "over_elig_date",
          format: formatEligBool,
          filters: [
            {
              text: "Yes",
              value: true
            },
            {
              text: "No",
              value: false
            }
          ]
        },
        {
          header: "Insurance",
          field: "insurance_type",
          filters: insuranceTypeNames,
          filterKey: "insurance_type_id"
        },
        {
          header: "Requires Compliance",
          field: "insurance_requires_compliance",
          format: ({ insurance_requires_compliance }) => insurance_requires_compliance ? "Yes" : "No",
          filters: [
            {
              text: "Yes",
              value: true
            },
            {
              text: "No",
              value: false
            }
          ],
          filterKey: "insurance_requires_compliance"
        },
        {
          header: "Outreach Date",
          format: ({ outreach_date }) => formatDate(outreach_date),
          field: "outreach_date"
        }
      ],
      customDisplay: [
        () =>
          markedForBatch.length > 0 ? (
            <span style={{ color: "white" }}>
              {markedForBatch.length} Patients Selected
            </span>
          ) : null
      ],
      customButtons: [
        {
          component: () => (
            <TableControls
              selectedPatients={markedForBatch}
              setSelectedPatients={markForBatch}
              setPatientBatchIds={markForBatch}
              handleRefresh={requestData}
              batchClear={batchClear}
            />
          )
        }
      ]
    })
  ),
  withHeaderFooter({
    perPageOptions: [500, 1000, 3000],
    forceBatchReset: true,
    perPageLimit: 10000,
    scrollable: true,
    showCount: true
  }),
  withTableHandlers()
)(Table);

export default SleepcoachDashboardTable;
